class JavascriptInjectedSectionHamburger extends HTMLElement {
  constructor() {
    super();
    this.targetLocation = this.getAttribute('data-target-location');
    this.rendered = false; // Ensure fetch happens only once
  }

  connectedCallback() {
    // Listen to the click event on the trigger
    const trigger = document.querySelector('[aria-controls="menu-drawer"]');
    
    if (trigger) {
      trigger.addEventListener('click', () => this.injectContent());
    }
  }

  async injectContent() {
    if (this.rendered) return; // Prevent multiple fetch calls

    const snippetURL = window.location.pathname + "?section_id=sections--25842877759795__header_drawer_NhemqC"; // Modify as needed

    const loader = document.querySelector("#menu-drawer .menu_placeholder"); // Select the loader
    if (loader) {
      loader.classList.remove('hidden'); // Show the loader
    }
    
    
    try {
      const response = await fetch(snippetURL);
      if (!response.ok) {
        throw new Error(`Failed to fetch section: ${response.status}`);
      }
  
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(await response.text(), 'text/html');
  
      // Extract the inner content you want (e.g., a specific div or snippet wrapper)
      const snippetContent = htmlDocument.querySelector('#header-drawer-content');
      if (snippetContent) {
        document.querySelector('#menu-drawer').innerHTML = snippetContent.innerHTML;
      } else {
        console.warn('Could not find #header-drawer-content in fetched section.');
      }
    } catch (error) {
      console.error('Error fetching section:', error);
    } finally {
            // Hide the loader after content is fetched or on error
            if (loader) {
              loader.classList.add('hidden');
            }
            this.rendered = true; // Mark as rendered
    }
  }

  renderContent(html) {
    const targetElement = document.querySelector(this.targetLocation);
    if (targetElement) {
      targetElement.innerHTML = html;
      this.rendered = true; // Mark as rendered to avoid repeated fetches
    } else {
      console.warn(`Target location ${this.targetLocation} not found`);
    }
  }
}

// Define the custom component
document.addEventListener('DOMContentLoaded', () => {
  customElements.define('javascript-injected-section-hamburger', JavascriptInjectedSectionHamburger);
});